import { render } from "./RandomColor.vue?vue&type=template&id=1e849050&scoped=true"
import script from "./RandomColor.vue?vue&type=script&lang=js"
export * from "./RandomColor.vue?vue&type=script&lang=js"

import "./RandomColor.vue?vue&type=style&index=0&id=1e849050&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e849050"

export default script